// extracted by mini-css-extract-plugin
module.exports = {"root":"_3-XqhV3GAd9QpROv6RrNf8","option":"_2t9FIpmOnCpaEkmplxImNs","selection":"_3Xx3kwjkzIMNESnVC0XNuT"};